import React, { useState, useEffect } from 'react';

// Linear Progress Bar Component
const ProgressBar = ({
  progress = 0,
  height = 8,
  color = 'bg-blue-500',
  backgroundColor = 'bg-gray-200',
  animated = true,
  showPercentage = true,
  indeterminate = false,
  className = '',
}) => {
  return (
    <div className={`w-full ${className}`}>
      {showPercentage && !indeterminate && (
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-gray-700">Loading...</span>
          <span className="text-sm font-medium text-gray-700">{Math.round(progress)}%</span>
        </div>
      )}
      {indeterminate && (
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-gray-700">Loading...</span>
        </div>
      )}
      <div className={`w-full rounded-full overflow-hidden ${backgroundColor}`} style={{ height }}>
        {indeterminate ? (
          <div className="h-full relative">
            <div
              className={`absolute h-full rounded-full ${color}`}
              style={{
                width: '40%',
                animation: 'indeterminateProgress 2s infinite linear',
                background: `linear-gradient(90deg, 
                  rgba(59, 130, 246, 0.3) 0%, 
                  rgba(59, 130, 246, 1) 50%, 
                  rgba(59, 130, 246, 0.3) 100%)`,
              }}
            />
            <style>{`
              @keyframes indeterminateProgress {
                0% {
                  left: -40%;
                }
                100% {
                  left: 100%;
                }
              }
            `}</style>
          </div>
        ) : (
          <div
            className={`h-full rounded-full transition-all duration-300 ease-out ${color} ${animated ? 'animate-pulse' : ''}`}
            style={{
              width: `${Math.min(Math.max(progress, 0), 100)}%`,
              background: animated
                ? `linear-gradient(90deg, 
                rgba(59, 130, 246, 0.8) 0%, 
                rgba(59, 130, 246, 1) 50%, 
                rgba(59, 130, 246, 0.8) 100%)`
                : undefined,
            }}
          />
        )}
      </div>
    </div>
  );
};

// Main Demo Component
export default function DelgroProgressBar() {
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  // Fixed: Stop infinite loop by not resetting to 0
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval); // Stop the interval
          return 100; // Stay at 100, don't reset to 0
        }
        return prev + Math.random() * 10;
      });
    }, 800); // Increased from 500ms to 800ms

    return () => clearInterval(interval);
  }, []);

  // Fixed: Proper cleanup
  useEffect(() => {
    if (!isLoading) return;

    const timeoutId = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isLoading]);

  return (
    <div className="max-w-5xl mx-auto">
      {/* Progress Bar Examples */}
      <section className="space-y-">
        <div className="space-y-2">
          <div>
            <ProgressBar progress={progress} />
          </div>

        </div>
      </section>
    </div>
  );
}
